/* * 本页面为冷柜监测点新增和冷柜监测点修改界面 *
通过pageType字段来区分：1新增，2修改 * */
<template>
  <div ref="pageView" class="page-view container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title>
        {{ pageTitle }}
        <template slot="breadcrumb">
          <e6-breadcrumb :breadcrumbs="breadcrumbs"></e6-breadcrumb>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- content -->
    <section
      class="content-section"
      :style="{ height: resizeViewHeight + 'px' }"
    >
      <div class="form-wrapper">
        <e6-form-extend
          class="e6-from--column-2"
          ref="formExtend"
          :formExtend="formExtend"
          :inline="true"
          label-width="200px"
          :submitLoadingState="loadingState"
          @submitForm="handleSubmitForm"
          @resetForm="handleResetForm"
        >
          <template slot-scope="slotForms">
            <el-form-item
            v-if="pageType==1"
              prop="forms.storeId"
              label="所属门店"
              :rules="[
                {
                  required: true,
                  message: '请选择所属门店',
                  trigger: 'change'
                }
              ]"
            >
              <el-select
                v-model="slotForms.forms.storeId"
                collapse-tags
                @change="storeChange"
                clearable
                filterable
                placeholder="所属门店"
              >
                <el-option
                  v-for="item in allStoreInfo"
                  :key="item.storeId"
                  :label="item.storeName"
                  :value="item.storeId"
                ></el-option>
              </el-select>
              &nbsp;
              <router-link
              :to="{
                path: '/baseStoreEdit',
              }"
              >新增门店</router-link
            >
            </el-form-item>
            
            <el-form-item
            v-if="pageType==2"
              prop="forms.storeId"
              label="所属门店"
              :rules="[
                {
                  required: true,
                  message: '请选择所属门店',
                  trigger: 'change'
                }
              ]"
            >
              <el-select
                v-model="slotForms.forms.storeId"
                collapse-tags
                @change="storeChange"
                clearable
                disabled
                filterable
                placeholder="所属门店"
              >
                <el-option
                  v-for="item in allStoreInfo"
                  :key="item.storeId"
                  :label="item.storeName"
                  :value="item.storeId"
                ></el-option>
              </el-select>
              
            </el-form-item>
            <el-form-item
            v-if="pageType==1"
              prop="forms.freezerId"
              label="所属冷柜"
              :rules="[
                {
                  required: true,
                  message: '请选择所属冷柜',
                  trigger: 'change'
                }
              ]"
            >
              <el-select
                v-model="slotForms.forms.freezerId"
                collapse-tags
                clearable
                filterable
                placeholder="所属冷柜"
              >
                <el-option
                  v-for="item in allFreezerInfo"
                  :key="item.freezerId"
                  :label="item.freezerName"
                  :value="item.freezerId"
                ></el-option>
              </el-select>
              &nbsp;
              <router-link
              :to="{
                path: '/baseFreezerEdit',
              }"
              >新增冷柜</router-link
            >
            </el-form-item>
            <el-form-item
            v-if="pageType==2"
              prop="forms.freezerId"
              label="所属冷柜"
              :rules="[
                {
                  required: true,
                  message: '请选择所属冷柜',
                  trigger: 'blur'
                }
              ]"
            >
              <el-select
              disabled
                v-model="slotForms.forms.freezerId"
                collapse-tags
                clearable
                filterable
                placeholder="所属冷柜"
              >
                <el-option
                  v-for="item in allFreezerInfo"
                  :key="item.freezerId"
                  :label="item.freezerName"
                  :value="item.freezerId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="监测点名称"
              prop="forms.labelName"
              :rules="[
                {
                  required: true,
                  message: '请输入监测点名称',
                  trigger: 'blur'
                },
                 { validator: CheckComparyNameLength, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.labelName"
                placeholder="监测点名称"
                clearable
                @blur="checkLabelName"
              ></el-input>

              <div :class="{ alarmColor: labelNameAlarmFlag }">
                {{ labelNameMessage }}
              </div>
            </el-form-item>
            <el-form-item
              label="监测点唯一标识码"
              prop="forms.uuid"
              :rules="[
                {
                  required: true,
                  message: '请输入监测点唯一标识码',
                  trigger: 'blur'
                },
                { validator: CheckComparyNameLength, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.uuid"
                placeholder="监测点唯一标识码"
                clearable
                @blur="checkLabelUuid"
              ></el-input>
              <div :class="{ alarmColor: labelUuidAlarmFlag }">
                {{ labelUuidMessage }}
              </div>
            </el-form-item>
          </template>
          <template slot="submit">保存</template>
          <template slot="reset">返回</template>
        </e6-form-extend>
      </div>
    </section>
    <!-- content end -->
  </div>
</template>
<script>
import {
  FindFreezerLabelInfoById,
  SaveFreezerLabelInfo,
  CheckNameUniqueData
} from '@/api/base/freezerLabel'
import{FindStoreInfoAll} from '@/api/base/store'
import{FindFreezerInfoByStoreId} from '@/api/base/freezer'
import resizeListener from '_private/mixins/resizeListener'
import { CheckRemarkLength,CheckComparyNameLength } from '@/utils/validation'
export default {
  mixins: [resizeListener],
  data() {
    return {
      breadcrumbs: [
        {
          path: '/home',
          isRedirect: true,
          meta: {
            title: '首页'
          }
        },
        {
          path: '/baseFreezerLabelList',
          isRedirect: true,
          meta: {
            title: '冷柜监测点'
          }
        }
      ],
      formExtend: {
        forms: {
          freezerId:'',
          storeId: '',
          labelName: '',
          uuid: ''
        },
        extends: []
      },
      labelNameMessage: '',
      labelUuidMessage: '',
      labelNameAlarmFlag: false,
      labelUuidAlarmFlag: false,
      editState: false,
      CheckRemarkLength: CheckRemarkLength,
      CheckComparyNameLength:CheckComparyNameLength,
      loadingState: false,
      allStoreInfo:[],
      allFreezerInfo:[],
      isFirstLoad: true
    }
  },
  computed: {
    pageType() {
      return this.$route.query.pageType ? this.$route.query.pageType : '1'
    },
    pageTitle() {
      const pageTitle =
        this.pageType === '1' ? '冷柜监测点新增' : '冷柜监测点修改'
      return pageTitle
    },
    id() {
      return this.$route.query.id
    },
    storeId(){
      return this.$route.query.storeId
    }
  },
  created() {
    this.initAllStore()
    let breadcrumb = {
      path: '/systemSettingDataDictionaryMaintenanceEdit',
      isRedirect: false,
      meta: {
        title: this.pageTitle
      }
    }
    this.breadcrumbs.push(breadcrumb)
    if (this.pageType !== '1') {
      this.  FindFreezerLabelInfoById({ labelId: this.id })
      this.editState = true
    }
  },
  mounted() {
    
  },
  methods: {
    /**
     * 初始化门店下拉框
     */
    initAllStore() {
      FindStoreInfoAll()
      .then(response => {
        if(response.result &&
            response.result &&
            Array.isArray(response.result)) {
              this.allStoreInfo = response.result
            }
      })
    },
    //门店选择事件
    storeChange() {
      this.allFreezerInfo = []
      this.formExtend.forms.freezerId = ''
      this.FindFreezerInfoByStoreId({storeId:this.formExtend.forms.storeId})
    },
    /**
     * 初始化冷柜下拉框
     */
    FindFreezerInfoByStoreId(storeId) {
      FindFreezerInfoByStoreId(storeId)
      .then(response => {
        if(response.result &&
            response.result &&
            Array.isArray(response.result)) {
              this.allFreezerInfo = response.result
            }
      })
    },
    /**
     * 校验监测点名称唯一性
     */
    checkLabelName() {
      if(this.formExtend.forms.labelName&&this.formExtend.forms.labelName.indexOf(" ")==-1) {
      CheckNameUniqueData({
        freezerId:this.formExtend.forms.freezerId,
        labelName: this.formExtend.forms.labelName,
        labelId: this.id
      }).then(response => {
        if (response.code == 0) {
          if (response.message) {
            this.labelNameAlarmFlag = true
            this.labelNameMessage = response.message
          }
        }else {
          this.labelNameAlarmFlag = false
            this.labelNameMessage = response.message
        }
      })
      }
    },
    //校验唯一码唯一性
    checkLabelUuid() {
      if(this.formExtend.forms.uuid&&this.formExtend.forms.uuid.indexOf(" ")==-1) {
      CheckNameUniqueData({
        freezerId:this.formExtend.forms.freezerId,
        uuid: this.formExtend.forms.uuid,
        labelId: this.id
      }).then(response => {
        if (response.code == 0) {
          if (response.message) {
            this.labelUuidAlarmFlag = true
            this.labelUuidMessage = response.message
          }
        }else {
          this.labelUuidAlarmFlag = false
            this.labelUuidMessage = response.message
        }
      })
      }
    },
    
    
    // 修改冷柜监测点数据时，先获取冷柜监测点数据信息
    FindFreezerLabelInfoById(response) {
      FindFreezerLabelInfoById(response)
        .then(response => {
         
          this.formExtend.forms = Object.assign({}, response.result)
          this.formExtend.forms.storeId = this.storeId
          this.FindFreezerInfoByStoreId({storeId:this.storeId})
        })
        .catch(error => {
          console.log(error)
        })
    },

    // 新增，修改冷柜监测点数据
    SaveFreezerLabelInfo(response) {
      SaveFreezerLabelInfo(response)
        .then(response => {
          this.submitCallback(response)
        })
        .catch(error => {
          console.log(error)
        })
    },
    // 新增冷柜监测点信息完成时的回调函数
    submitCallback(response) {
      let type = response.code === 1 ? 'success' : 'error'
      let message = response.message
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 2000,
        onClose: () => {
          if (type === 'success') {
            this.$router.push({
              path: '/baseFreezerLabelList',
              query: { refreshportion: true }
            })
          }
          this.loadingState = false
        }
      })
    },
    // 提交
    handleSubmitForm(e) {
      if (e&&!this.labelNameAlarmFlag&&!this.labelUuidAlarmFlag) {
        this.loadingState = true
        this.SaveFreezerLabelInfo(Object.assign({}, this.formExtend.forms))
      }
    },
    // 取消
    handleResetForm() {
      this.$router.push('/baseFreezerLabelList')
    }
  }
}
</script>

<style lang="scss" scoped>
.alarmColor {
  margin-bottom: -21px;
  margin-top: -5px;
  font-size: 12px;
  color: #f56c6c;
}
.page-view {
  height: 100%;
}
.title-section {
  padding: 15px 20px 10px;
}
.content-section {
  overflow: auto;
}
.content-section {
  .form-wrapper {
    padding-top: 20px;
    margin: 0 20px;
    background-color: #fff;
  }
}
/deep/ .e6-from--column-2 {
  .el-input {
    width: 300px;
  }
  .el-textarea__inner {
    width: 500px;
  }
}
</style>
